import {
  SettingOutlined,
  DatabaseOutlined,
  GlobalOutlined,
  ApiOutlined,
  AuditOutlined,
} from '@ant-design/icons';
import type { SidebarConfig } from './types';

export const settingsSidebar: SidebarConfig = {
  module: 'settings',
  titleKey: 'common:nav.settings',
  icon: <SettingOutlined />,
  sections: [
    {
      key: 'configuration',
      labelKey: 'settings:sidebar.sections.configuration',
      items: [
        { key: 'data', path: '/settings/data', labelKey: 'settings:tabs.data', icon: <DatabaseOutlined /> },
        { key: 'localization', path: '/settings/localization', labelKey: 'settings:tabs.localization', icon: <GlobalOutlined /> },
        { key: 'integrations', path: '/settings/integrations', labelKey: 'settings:tabs.integrations', icon: <ApiOutlined /> },
      ],
    },
    {
      key: 'governance',
      labelKey: 'settings:sidebar.sections.governance',
      items: [
        { key: 'audit', path: '/settings/audit', labelKey: 'settings:tabs.audit', icon: <AuditOutlined /> },
      ],
    },
  ],
};
